import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'us-east-1_9NVf6Pz3e', // your user pool id
  ClientId: '5vbhldlu8uhcvba8rvvngogjpv', // your client id
};

export default new CognitoUserPool(poolData);
